import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  JiraAuthentication,
  GitHubAuthentication,
} from "@/components/integrations";
import { PanelCard } from "@/components/common";

/**
 * IntegrationsAccounts.
 */
const __default__ = {
  name: "IntegrationsAccounts",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { title: "Integration Sources" }, {
    default: _withCtx(() => [
      _createVNode(_unref(JiraAuthentication), { inactive: "" }),
      _createVNode(_unref(GitHubAuthentication), { inactive: "" })
    ]),
    _: 1
  }))
}
}

})